import React from 'react';
import {
  BanIcon,
  CheckCircleIcon,
  ExclamationTriangleIcon,
  InProgressIcon,
  QuestionCircleIcon,
} from '@patternfly/react-icons';

const statusBadgeColors = {
  dangerIcon: 'var(--pf-global--danger--red-100)',
  dangerColor: 'var(--pf-global--danger--red-200)',
  dangerBackground: 'var(--pf-global--palette--red-100)',
  successIcon: 'var(--pf-global--success-color--100)',
  successColor: 'var(--pf-global--success-color--200)',
  successBackground: 'var(--pf-global--palette--green-100)',
  warningIcon: 'var(--pf-global--warning-color--100)',
  warningColor: 'var(--pf-global--warning-color--200)',
  warningBackground: 'var(--pf-global--palette--gold-100)',
  purpleBackground: 'var(--pf-global--palette--purple-100)',
  purpleIcon: 'var(--pf-global--palette--purple-100)',
  purpleColor: 'var(--pf-global--palette--purple-900)',
  blueBackground: 'var(--pf-global--palette--blue-100)',
  blueIcon: 'var(--pf-global--palette--blue-100)',
  blueColor: 'var(--pf-global--palette--blue-900)',
};

const StatusBadgeLayout = ({
  icon,
  label,
  backgroundColor,
  textColor,
  ...props
}: {
  icon?: React.ReactNode;
  label: string;
  backgroundColor: string;
  textColor: string;
}) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0 .5rem',
        borderRadius: '6px',
        backgroundColor,
        color: textColor,
      }}
      {...props}
    >
      {icon && <div>{icon}</div>}
      <div style={{ marginLeft: icon ? '.3rem' : 0 }}>{label}</div>
    </div>
  );
};

export const BlueBadge = ({ label, ...props }: { label: string; [key: string]: unknown }): JSX.Element =>
  StatusBadgeLayout({
    label,
    backgroundColor: statusBadgeColors.blueBackground,
    textColor: statusBadgeColors.blueColor,
    ...props,
  });
export const PurpleBadge = ({ label, ...props }: { label: string; [key: string]: unknown }): JSX.Element =>
  StatusBadgeLayout({
    label,
    backgroundColor: statusBadgeColors.purpleBackground,
    textColor: statusBadgeColors.purpleColor,
    ...props,
  });
export const SuccessBadge = ({ label, ...props }: { label: string; [key: string]: unknown }): JSX.Element =>
  StatusBadgeLayout({
    icon: <CheckCircleIcon color={statusBadgeColors.successIcon} />,
    label,
    backgroundColor: statusBadgeColors.successBackground,
    textColor: statusBadgeColors.successColor,
    ...props,
  });
export const WarningBadge = ({ label, ...props }: { label: string; [key: string]: unknown }): JSX.Element =>
  StatusBadgeLayout({
    icon: <InProgressIcon color={statusBadgeColors.warningIcon} />,
    label,
    backgroundColor: statusBadgeColors.warningBackground,
    textColor: statusBadgeColors.warningColor,
    ...props,
  });
export const UnknownBadge = ({ label, ...props }: { label: string; [key: string]: unknown }): JSX.Element =>
  StatusBadgeLayout({
    icon: <QuestionCircleIcon color={statusBadgeColors.warningIcon} />,
    label,
    backgroundColor: statusBadgeColors.warningBackground,
    textColor: statusBadgeColors.warningColor,
    ...props,
  });
export const DangerBadge = ({ label, ...props }: { label: string; [key: string]: unknown }): JSX.Element =>
  StatusBadgeLayout({
    icon: <ExclamationTriangleIcon color={statusBadgeColors.dangerIcon} />,
    label,
    backgroundColor: statusBadgeColors.dangerBackground,
    textColor: statusBadgeColors.dangerColor,
    ...props,
  });
export const DisabledBadge = ({ label, ...props }: { label: string; [key: string]: unknown }): JSX.Element =>
  StatusBadgeLayout({
    icon: <BanIcon color={statusBadgeColors.dangerIcon} />,
    label,
    backgroundColor: statusBadgeColors.dangerBackground,
    textColor: statusBadgeColors.dangerColor,
    ...props,
  });
